export default __webpack_public_path__ + "static/media/ico-doc-db-score-high.61b5eefb.svg";